export const checkBookmark = (bookmarks, item) => !bookmarks.some(bookmark => bookmark._id === item._id) 